import { z } from "zod";

const InventoryCategoryResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        id: z.string().uuid(),
        property_id: z.string().uuid(),
        name: z.string(),
        created_at: z.string().datetime(),
        updated_at: z.string().datetime(),
    }),
});

export { InventoryCategoryResponseSchema };
export type InventoryCategoryResponse = z.infer<typeof InventoryCategoryResponseSchema>;
